export default __webpack_public_path__ + "static/media/care_health_insurance_logo.0ff21265.svg";